/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import { ApiCreateFileStorageHttpDto } from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class FileStorage<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags File Storage
   * @name FileStorageControllerUploadFile
   * @summary Upload a file to storage
   * @request POST:/file-storage
   * @secure
   * @response `201` `string` File uploaded successfully and path returned
   */
  fileStorageControllerUploadFile = (
    data: ApiCreateFileStorageHttpDto,
    params: RequestParams = {},
  ) =>
    this.request<string, ApiBaseError>({
      path: `/file-storage`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags File Storage
   * @name FileStorageControllerGetFile
   * @summary Get a file from storage by filename
   * @request GET:/file-storage/{filename}
   * @secure
   * @response `200` `string` File content successfully retrieved
   * @response `403` `void` Access denied to retrieve the specified file
   */
  fileStorageControllerGetFile = (
    filename: string,
    params: RequestParams = {},
  ) =>
    this.request<string, ApiBaseError>({
      path: `/file-storage/${filename}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags File Storage
   * @name FileStorageControllerDeleteFile
   * @summary Delete a file from storage by filename
   * @request DELETE:/file-storage/{filename}
   * @secure
   * @response `204` `void` File successfully deleted from storage
   * @response `400` `void` File not found or access denied
   */
  fileStorageControllerDeleteFile = (
    filename: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/file-storage/${filename}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
